import Vue from 'vue'
import App from './App.vue'
import MintUI from 'mint-ui'
import router from './router.js'
import store from './store/index.js'
import "mint-ui/lib/style.css"
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import ba from 'vue-ba'

Vue.config.productionTip = false
Vue.use(MintUI)
Vue.use(VueAwesomeSwiper)
Vue.use(ba, 'e9f1b93cdda681220815e87f273b945d')
Vue.use(ba, { siteId: "e9f1b93cdda681220815e87f273b945d" });

router.beforeEach((to, from, next) => {
  if ((from.path === '/orderList' && to.path === '/preview')||(from.path === '/orderList' && to.path === '/print')) {
    next(false);
  } else {
    next();
  }
});



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
